var gdtCartData = document.getElementById('gdt-cart-up-sell-data')
var upSellArr = {
  1: {
    id: gdtCartData.getAttribute('data-up-sell-1'),
    requireId: gdtCartData.getAttribute('data-up-sell-require-1')
  },
  2: {
    id: gdtCartData.getAttribute('data-up-sell-2'),
    requireId: gdtCartData.getAttribute('data-up-sell-require-2')
  },
  3: {
    id: gdtCartData.getAttribute('data-up-sell-3'),
    requireId: gdtCartData.getAttribute('data-up-sell-require-3')
  }
}


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate(() => {});
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  updateUpSell() {
    fetch("/cart.json")
    .then((response) => response.text())
    .then((responseText) => {
      const jsonData = JSON.parse(responseText);
      let isOnlyUpsell = true

      if (jsonData.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, jsonData.errors);
        return;
      } else {
        
        // Clear cart if only upsell left in
        for (let i = 0; i < jsonData.items.length; i++) {
          let item = jsonData.items[i]
          let isUpSell = false
          let upSellRequireProductID
          
          for (let i = 1; i <= 3; i++) { 
            // This product is an upsell
            if (upSellArr[i].id == item.id) {
              isUpSell = true
              upSellRequireProductID = upSellArr[i].requireId
            }
          }

          if (!isUpSell) {
            isOnlyUpsell = false
          } else {
            // Verify than the upsell have its associated product in cart
            let upSellHaveItsRequirement = false
            for (let i = 0; i < jsonData.items.length; i++) {
              let itemCheck = jsonData.items[i]
              if (upSellRequireProductID == itemCheck.id) {
                upSellHaveItsRequirement = true
              }
            }
            
            if (!upSellHaveItsRequirement) {
              // Remove the upsell
              CartJS.removeItemById(item.id, {
                "success": (data, textStatus, jqXHR) => {
                },
                "error": (jqXHR, textStatus, errorThrown) => {
                  //console.log('Error: ' + errorThrown + '!');
                }
              });
              
            }
          }
        }

        // Clear cart
        if (isOnlyUpsell) {
          CartJS.clear({
            "success": (data, textStatus, jqXHR) => {

            },
            "error": (jqXHR, textStatus, errorThrown) => {
              //console.log('clear Error: ' + errorThrown + '!');
            }
          });


        }

      }


    })
  }

  onCartUpdate(callback) {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          this.renderCartBubble()
          callback();
        })
        .catch((e) => {
          //console.error(e);
          callback();
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          //console.error(e);
        });
    }
  }

  renderCartBubble() {
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const targetElement = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      const sourceElement = html.querySelector('.cart-count-bubble');
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      } else if (!sourceElement) {
        // Qty 0
        document.querySelector('cart-drawer').classList.add('is-empty')
        document.querySelector('cart-drawer cart-drawer-items').classList.remove('is-empty')

        targetElement.remove()
      }
    })
    .catch((e) => {
      //console.error(e);
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.updateUpSell();
        this.disableLoading(line);
      });

      setTimeout(function() {
        initSlider(); 
        cloneShippingDelay();
        drawerTranslation();
      }, 3000);
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    const loadingSpinnerTotal = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinnerTotal.classList.remove('hidden')

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));

    const loadingSpinnerTotal = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinnerTotal.classList.add('hidden')
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


class CartAddCrossSell extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick)
  }

  handleClick = (event) => {
    event.preventDefault();
    const elementData = this.parentNode.parentNode
    let variant_id = elementData.dataset.variantId
    let isFromModal = false
    if (!variant_id) {
      variant_id = event.target.dataset.variantId
      isFromModal = true

      const parentElement = this.parentNode;
      const loadingSpinner = parentElement.querySelector('.loading__spinner');
      this.classList.add('cart__items--disabled');
      loadingSpinner.classList.remove('hidden')
    }

    if (variant_id) {
      CartJS.addItem(variant_id, 1, {
        "success": (data, textStatus, jqXHR) => {
          if (!isFromModal) {
            this.enableLoading()
          }
        },
        "error": (jqXHR, textStatus, errorThrown) => {
          //console.log('Error: ' + errorThrown + '!');
        }
      });
    }
  }

  enableLoading = () => {
    const parentElement = this.parentNode;
    const loadingSpinner = parentElement.querySelector('.loading__spinner');
    this.classList.add('cart__items--disabled');
    loadingSpinner.classList.remove('hidden')
    const loadingSpinnerTotal = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinnerTotal.classList.remove('hidden')
  }

  disableLoading = () => {
    const parentElement = this.parentNode;
    const loadingSpinner = parentElement.querySelector('.loading__spinner');
    this.classList.remove('cart__items--disabled');
    loadingSpinner.classList.add('hidden')
    const loadingSpinnerTotal = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinnerTotal.classList.add('hidden')
  }
}

customElements.define("cart-add-cross-sell", CartAddCrossSell);


class CartChangeUpSell extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input')
    this.input.addEventListener('change', this.handleInputChange);
  }
  
  handleInputChange = (event) => {
    event.preventDefault();
    let variant_id = this.parentNode.parentNode.dataset.variantId
    
    if (!this.input.checked) {
      CartJS.removeItemById(variant_id, {
        "success": (data, textStatus, jqXHR) => {
          this.enableLoading()
        },
        "error": (jqXHR, textStatus, errorThrown) => {
          //console.log('Error: ' + errorThrown + '!');
        }
      });

    } else {
      CartJS.addItem(variant_id, 1, {
        "success": (data, textStatus, jqXHR) => {
          this.enableLoading()
        },
        "error": (jqXHR, textStatus, errorThrown) => {
        }
      });
    }
  }

  enableLoading = () => {
    const loadingSpinner = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinner.classList.remove('hidden')
    this.classList.add('cart__items--disabled');
  }

  disableLoading = () => {
    const loadingSpinner = document.querySelector('#gdt_total_cart .loading__spinner');
    loadingSpinner.classList.add('hidden')
    this.classList.remove('cart__items--disabled');
  }
}

customElements.define("cart-change-up-sell", CartChangeUpSell);


class CartAddUpSell extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick);
  }

  handleClick = (event) => {
    event.preventDefault();
    let variant_id = this.dataset.variantId
    const parentElement = this.parentNode;
    const loadingSpinner = parentElement.querySelector('.loading__spinner');
    this.classList.add('cart__items--disabled');
    loadingSpinner.classList.remove('hidden')

    CartJS.addItem(variant_id, 1, {
      "success": (data, textStatus, jqXHR) => {
        const cartItems = document.querySelector('cart-drawer-items');
        cartItems.enableLoading()
      },
      "error": (jqXHR, textStatus, errorThrown) => {
      }
    });
  }
}

customElements.define("cart-add-up-sell", CartAddUpSell);

$(document).on('cart.requestComplete', (event, cart) => {
  const cartItems = document.querySelector('cart-drawer-items');
  cartItems.onCartUpdate(() => {
    document.querySelectorAll('cart-change-up-sell').forEach(changeUpSell => {
      changeUpSell.disableLoading(); 
    });
    
    setTimeout(function() {
      cloneShippingDelay();
      drawerTranslation();
    }, 1000);
  });
});

// Cart timer
/* if (document.getElementById('gdt-cart-timer')) {
  const delayInMinutes = 10;
  const delayInMillis = delayInMinutes * 60 * 1000;

  let startDate;
  const storedStartDate = localStorage.getItem('gdt_cart_timer_start');
  
  if (storedStartDate) {
    startDate = new Date(storedStartDate);
    const endTime = new Date(startDate.getTime() + delayInMillis);

    if (endTime > new Date()) {
      var end = endTime;
    } else {
      startDate = new Date();
      localStorage.setItem('gdt_cart_timer_start', startDate);
      var end = new Date(startDate.getTime() + delayInMillis);
    }
  } else {
    startDate = new Date();
    localStorage.setItem('gdt_cart_timer_start', startDate);
    var end = new Date(startDate.getTime() + delayInMillis);
  }
    
  const updateTimer = () => {
    let total_seconds = (end - new Date) / 1000
    let minutes = Math.floor(total_seconds / 60);
    total_seconds = total_seconds % 60;
    let seconds = Math.floor(total_seconds);

    if (total_seconds <= 0) {
      if (!shippingTimerInterval) { return }
      clearInterval(shippingTimerInterval);
      $('#gdt-cart-timer').text("");
    } else {
      $('#gdt-cart-timer').text(minutes + "min " + seconds + "sec");
    }
  }

  const shippingTimerInterval = setInterval(updateTimer, 1000);
  updateTimer();
} */

function initSlider() {
  let csSliderElem = $('cart-drawer .cs-products-images')
  if (csSliderElem) {
    setTimeout(function() {
      csSliderElem.slick({
        dots: false,
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '17px',
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }, 1500); 
  }
}

function cloneShippingDelay() {
  const shippingDelay = document.querySelector('.delivery-widget__container .msg__container p')
  let shippingCartCloneElemement = document.getElementById('shippingCart')
  if (!shippingCartCloneElemement) {return;}
  
  if (shippingDelay && shippingDelay.innerHTML != '') {
    let dateRegex = /(\d{1,2}\s\w+\s-\s\d{1,2}\s\w+)/;
    let dateMatch = shippingDelay.innerHTML.match(dateRegex);
    if (dateMatch) {
        let dateText = dateMatch[0];
        shippingCartCloneElemement.innerHTML = `Estimée entre : ${dateText}`;
    } else {
    shippingCartCloneElemement.innerHTML = shippingDelay.innerHTML
    }
  } else {
    shippingCartCloneElemement.innerHTML = ""
  }
}

function drawerTranslation() {
  const storeLang = Shopify.locale;
  
  const sizeElements = document.querySelectorAll('.tpo_cart-properties-wrapper .product-option dt');
  sizeElements.forEach(sizeElement => {
    if (sizeElement.textContent.trim() == "Taille du haut:") {
      if (storeLang == 'es') {
        sizeElement.textContent = "Talla del top:"
      }
    } else if (sizeElement.textContent.trim() == "Taille du bas:") {
      if (storeLang == 'es') {
        sizeElement.textContent = "Talla del bottom:"
      }
    }
  });

  if (storeLang == 'es') {
    const discountElements = document.querySelectorAll('.footer-row .discounts .discounts__discount span');
    discountElements.forEach(discountElement => {
      if (discountElement.textContent.trim() == "EXTRA -20€ EN CADEAU") {
        discountElement.textContent = 'EXTRA -20€ DE REGALO'
      }
    });
  }
  
}

document.addEventListener('DOMContentLoaded', function () {

  const targetNode = document.getElementById('shippingCart');
  const config = { attributes: true, childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
    for(let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          observer.disconnect();
          let content = targetNode.innerHTML;
          let dateRegex = /(\d{1,2}\s\w+\s-\s\d{1,2}\s\w+)/;
          let dateMatch = content.match(dateRegex);
          if (dateMatch) {
              let dateText = dateMatch[0];
              targetNode.innerHTML = `(${dateText})`;
          }
          observer.observe(targetNode, config);
        }
    }
  };
  
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  
  setTimeout(function() {
    initSlider(); 
    cloneShippingDelay();
    drawerTranslation();
  }, 4000);
});
